"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers = __importStar(require("ethers"));
const siwe_1 = __importDefault(require("siwe"));
async function generateAuthSigNode(privateKey, domain, origin, statement, chainId = 1) {
    const signer = new ethers.Wallet(privateKey);
    const siweMessage = new siwe_1.default.SiweMessage({
        domain: domain,
        address: await signer.getAddress(),
        statement,
        uri: origin,
        version: "1",
        chainId: chainId,
    });
    const messageToSign = siweMessage.prepareMessage();
    const signature = await signer.signMessage(messageToSign);
    const recoveredAddress = ethers.utils.verifyMessage(messageToSign, signature);
    console.log("-------------------------------------");
    console.log("Signer address and recovered address", await signer.getAddress(), recoveredAddress);
    console.log("-------------------------------------");
    return {
        sig: signature,
        derivedVia: "web3.eth.personal.sign",
        signedMessage: messageToSign,
        address: recoveredAddress,
    };
}
exports.default = generateAuthSigNode;
